module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c933a7ce574d3814b59f16e5019fc327.png";